import { Chart } from 'chart.js';

let registered = false;

/** Registra una sola vez las etiquetas numéricas del gráfico de guías. */
export function registerDashboardChartPlugin(): void {
  if (registered) return;

  Chart.register({
    id: 'dashboardLabels',
    afterDatasetsDraw: (chart: any) => {
      const dataset = chart.data.datasets && chart.data.datasets[0];
      const meta = chart.getDatasetMeta(0);
      if (!dataset || !meta || !meta.data) return;

      const context = chart.ctx;
      context.save();
      context.fillStyle = '#ffffff';
      context.font = '700 16px Arial';
      context.textAlign = 'center';
      context.textBaseline = 'middle';

      meta.data.forEach((arc: any, index: number) => {
        const value = Number(dataset.data[index]) || 0;
        if (!value || typeof arc.getProps !== 'function') return;

        const props = arc.getProps(
          ['x', 'y', 'startAngle', 'endAngle', 'innerRadius', 'outerRadius'],
          true,
        );
        const angle = (props.startAngle + props.endAngle) / 2;
        const radius = (props.outerRadius + props.innerRadius) / 2;
        context.fillText(
          String(value),
          props.x + Math.cos(angle) * radius,
          props.y + Math.sin(angle) * radius,
        );
      });

      context.restore();
    },
  });

  registered = true;
}
